import { useState } from 'react';

import { useCheckout } from '@hooks';

import {
  ContainerWrapper,
  getQueryParam,
  parserTransactionsTypes,
  redirect,
  setToken,
} from '@utils';
import { If, Loader, Tabs } from '@ui';
import {
  useGetCheckoutQuery,
  useGetEnterAmountQuery,
  useGetGatesQuery,
} from '@entities/checkout';
import { WebSites } from '@constants';

export const Home = () => {
  const [gate, setGate] = useState<string>('');

  const payment = getQueryParam('payment');
  const paymentUUID = getQueryParam('paymentUUID');

  const { data } = useGetGatesQuery(payment);
  const { data: enterAmount, isError: enterAmountQueryError } =
    useGetEnterAmountQuery(paymentUUID);

  if (payment) {
    setToken(payment);
  }

  if (paymentUUID && enterAmount?.payload?.sessionToken) {
    setToken(enterAmount?.payload?.sessionToken);
  }

  const route: any = document.querySelector('meta[name="route"]');
  const url: string = route?.content;

  // const defaultGate: any = document.querySelector('meta[name="defaultGate"]');

  const { handleSetCheckout } = useCheckout();
  const {
    data: checkout,
    isLoading,
    isSuccess,
    isError,
  } = useGetCheckoutQuery();

  if (isLoading) {
    return <Loader />;
  }

  if ((isError && !url) || enterAmountQueryError) {
    redirect(WebSites.AlifTj);
  }

  const [headers, childes] = parserTransactionsTypes(
    checkout,
    false,
    enterAmount
  );

  if (isSuccess) {
    handleSetCheckout(checkout);
  }

  // setTimeout(() => {
  //   setGate(data?.gate || defaultGate?.content);
  // }, 500);

  // if (!gate) {
  //   return <Loader />;
  // }

  return (
    <ContainerWrapper>
      <div className="my-[120px] sm:my-[44px]">
        <div className="mx-auto flex w-[65%] flex-col gap-10 sm:w-full sm:gap-2 sm:overflow-hidden">
          <If condition={headers.length !== 1}>
            <div className="mb-2 mt-10 sm:mt-0 sm:px-5">
              <p className="font-semibold">Выберите способ оплаты</p>
            </div>
          </If>
          <Tabs
            selectedDefault={data?.groupName || gate}
            headers={headers}
            childes={childes}
            onChange={() => null}
          />
        </div>
      </div>
    </ContainerWrapper>
  );
};
